import styled from 'styled-components'
import {BarBackground} from './components/progress/styles'

export const Wrapper = styled.div`
  background: ${({theme}): string => theme?.backgroundColorLight};
  padding: 16px 25px;
  transition: box-shadow 0.2s ease;
  margin-bottom: 16px;
  position: relative;

  &:hover,
  &:focus-within {
    box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.06);

    ${BarBackground} {
      opacity: 1;
    }
  }
`

export const ContainerList = styled.ul`
  list-style: none;
  margin: 4px 0 0 0;
  padding: 0;
`

export const ContainerEntry = styled.li`
  margin: 0;
`
